import React from "react";
import Currency from "react-currency-formatter";
import Text from "../../../../../../../../../_components/Text";
import Button from "../../../../../../../../../_components/Button";
import Row from "../../../../../../../../../_components/Layout/Row";
import Column from "../../../../../../../../../_components/Layout/Column";

import { _Input } from "../../../../../../../../../_components/Input";

import { CreateNFeContext } from "../../../../../Context";
import { PaymentContext } from "../../../context";
import { usePaymentScheduler, useInstallmentsValue } from "./hooks";

export default (props) => {
  const inputRef = React.useRef(null);
  const ref = React.useRef(null);
  const createNFeContext = React.useContext(CreateNFeContext);
  const paymentContext = React.useContext(PaymentContext);
  const [installments, setInstallments] = React.useState(1);
  const [installmentValue, setInstallmentValue] = React.useState(0);
  const [startDate, setStartDate] = React.useState(null);
  const [inputOptions, setInputOptions] = React.useState([]);

  function makeOptionsInstallment() {
    let date = new Date()
    date.setMonth(date.getMonth() + 1)
    setStartDate(date)
    let opts = [];
    const { nfe } = createNFeContext;

    for (let x of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) {
      const value = adaptInstallmentValue(nfe, x);
      opts.push({
        label: `${x}x de R$ ${value}`,
        value: value,
      });
    }
    setInputOptions(opts);
  }

  const setInvoices = usePaymentScheduler();
  const adaptInstallmentValue = useInstallmentsValue();

  function calculateTotalInvoice() {
    const value = adaptInstallmentValue(createNFeContext.nfe, installments);
    setInstallmentValue(value);
  }
  React.useEffect(calculateTotalInvoice, [installments]);
  React.useEffect(calculateTotalInvoice, [
    createNFeContext.nfe.identification.discount_value,
  ]);

  React.useEffect(makeOptionsInstallment, [
    ref.current
  ]);
  return (
    <Row className="py-4" ref={ref}>
      <Column col="6" xs="12">
        <Text color="primary">Primeiro Vencimento</Text>
        <_Input
          name="startDate"
          disabled={paymentContext.disabled}
          onChange={(e) => setStartDate(e.value)}
          type="date"
          value={startDate}
        />
      </Column>
      <Column col="6" xs="12">
        <Text color="primary">
          Parcelas: {installments}x de{" "}
          <Currency symbol="R$ " currency="BRL" quantity={installmentValue} />
        </Text>
        <_Input
          type="number"
          disabled={paymentContext.disabled}
          onChange={(e) => setInstallments(e.value)}
          ref={inputRef}
          min={1}
          value={installments}
        />
      </Column>
      <Column col="12" className="py-4">
        <Button
          disabled={paymentContext.disabled}
          onClick={() => setInvoices(startDate, installments, props.payment)}
        >
          Adicionar Parcelas
        </Button>
      </Column>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/AddPayment/Invoices/index.jsx